import React from 'react';
import { useParams } from 'react-router-dom';

import File from '@root/views/File/File';

const ArticleGenerator = () => {
  const params = useParams();

  return (
    <File
      id={params.id}
      templateType="articles"
      loadingTime="1.5 minutes"
      includeBlogCredits
      includeCreditsRight
      maxRewriteLength={400}
    />
  );
};

export default ArticleGenerator;
